import {Subscription} from 'rxjs';
import {streamingService, StreamMessageParams} from "../../services/streaming.service";
import {extractThinking} from "../../utils/chat-utils";

// TODO: move to models or utils
const CITATION_MARKER = 'CITATIONS:';
const HOLD_BACK = CITATION_MARKER.length;


export interface OnChunkPayload {
    cleanText: string;
    thinkingText: string;
    streamingText: string;
}

export interface StreamCallbacks {
    onChunk:    (payload: OnChunkPayload) => void;
    onError:    (err: Error) => void;
    onComplete: (streamingText: string) => void;
}

interface ActiveStream {
    subscription: Subscription;
}

export class StreamingConversationManager {
    private activeStreams = new Map<string, ActiveStream>();

    isStreaming(conversationId: string): boolean {
        return this.activeStreams.has(conversationId);
    }

    stopStream(conversationId: string): void {
        const active = this.activeStreams.get(conversationId);

        if (active) {
            active.subscription.unsubscribe();
            this.activeStreams.delete(conversationId);
        }
    }

    stopAll(): void {
        this.activeStreams.forEach(stream => stream.subscription.unsubscribe());
        this.activeStreams.clear();
    }

    startStream(conversationId: string, params: StreamMessageParams, callbacks: StreamCallbacks): void {
        this.stopStream(conversationId);

        // isolated buffer, one per conversation
        let buffer = '';

        const subscription = streamingService
            .createMessageStream(params)
            .subscribe({
                next: (chunk: string) => {
                    buffer += chunk;

                    let accumulatedText: string;
                    if (buffer.includes(CITATION_MARKER)) {
                        accumulatedText = buffer.slice(0, buffer.indexOf(CITATION_MARKER));
                    } else {
                        accumulatedText = buffer.length > HOLD_BACK
                            ? buffer.slice(0, -HOLD_BACK)
                            : '';
                    }

                    const { thinkingText, cleanText } = extractThinking(accumulatedText);

                    callbacks.onChunk({
                        cleanText,
                        thinkingText,
                        streamingText: buffer,
                    });
                },

                error: (err: Error) => {
                    this.activeStreams.delete(conversationId);
                    callbacks.onError(err instanceof Error ? err : new Error(String(err)));
                },

                complete: () => {
                    this.activeStreams.delete(conversationId);
                    callbacks.onComplete(buffer);
                },
            });

        this.activeStreams.set(conversationId, { subscription });
    }
}